// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"bc05a2b8","193":"bb5f9f03","453":"2cfb7246"}[chunkId] + ".chunk.js";
};